import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import "./modal.scss"

export default function Modal({ isOpen, onClose }) {
  const timeInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const recaptchaRef = useRef(null);

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({ name: "", email: "", date: new Date().toISOString().split("T")[0], time: "", message: "", package: "", newsletterSubscription: "No", "g-recaptcha-response": "" });
  const [captchaToken, setCaptchaToken] = useState("");

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const executeCaptchaManually = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    recaptchaRef.current.execute();
  };

  const handleFormSubmit = (token) => {
    if (!token) {
      alert("Please verify the CAPTCHA");
      return;
    }

    emailjs
      .send(
        "service_uvfkh54",
        "template_0kabt7e",
        { ...formData, "g-recaptcha-response": token },
        "CvviY1FFT0q_MuZ8k"
      )
      .then(() => {
        setFormData({ name: "", email: "", date: "", time: "", message: "", package: "", newsletterSubscription: 0 });
        setSuccessMessage("Thank you for your inquiry! One of our representatives will reach you within 24-48 hours.");
        setTimeout(() => {
          setSuccessMessage("");
          setIsSubmitting(false);
          onClose();
        }, 5000);

      })
      .catch((e) => {
        console.log(e);
        setSuccessMessage(<>
          Failed to send message. Please contact us at{" "} <a href="tel:+1-876-431-0549" style={{ color: "#ffffff" }}>
            +1-876-431-0549
          </a>.
        </>);
        setTimeout(() => {
          setSuccessMessage("");
          setIsSubmitting(false);
          onClose();
        }, 5000);
      });
  };

  const handleDateClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker(); // Open native date picker
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setFormData({ ...formData, ["date"]: e.target.value });
  };

  const handleSelectChange = (e) => {
    setFormData({ ...formData, ["package"]: e.target.value });
  };

  const handleNewsletterCheckbox = (e) => {
    setFormData({ ...formData, ["newsletterSubscription"]: e.target.checked ? "Yes" : "No" });
  };

  const handleClick = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // const handleOutsideClick = (e) => {
  //   if (e.target.classList.contains("modal")) {
  //     onClose();
  //   }
  // };

  if (!isOpen) return null;

  return (
    <>
      <div class="modal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button className="crossbtn" onClick={onClose}>&times;</button>
              <h2>Book Your Journey Now</h2>
              {successMessage ? (
                <p className="success-message">{successMessage}</p>
              ) : (
                <form onSubmit={executeCaptchaManually}>
                  <ul className="list-none">
                    <li>
                      <label
                        className={`input_label`}
                        htmlFor="name"
                      >
                        Name *
                      </label>
                      <input
                        className="input_field"
                        type="text"
                        id="name"
                        name="name"
                        onChange={handleFormChange}
                        minLength={2}
                        maxLength={99}
                        required
                      />
                    </li>
                    <li>
                      <label
                        className={`input_label`}
                        htmlFor="email"
                      >
                        E-mail *
                      </label>
                      <input
                        className="input_field"
                        type="email"
                        id="email"
                        name="email"
                        onChange={handleFormChange}
                        required
                        maxLength={100}
                      />
                    </li>
                    <li>
                      <label
                        className={`input_label`}
                      >
                        Date *
                      </label>
                      <input
                        className="input_field datefield"
                        type="text" // Keep this as text
                        id="date"
                        value={selectedDate}
                        name="date"
                        onClick={handleDateClick} // Click opens the hidden date input
                        readOnly // Prevent manual typing
                        required
                      />
                      <input
                        ref={dateInputRef}
                        className="hidden_date_input"
                        type="date" // Hidden input for date selection
                        onChange={handleDateChange} // Updates text input value
                      />
                    </li>
                    <li>
                      <label
                        className={`input_label active`}
                        htmlFor="time"
                      >
                        Time
                      </label>
                      <input
                        onClick={handleClick}
                        ref={timeInputRef}
                        className="input_field"
                        type="time"
                        id="time"
                        name="time"
                        onChange={handleFormChange}
                      />
                    </li>
                    <li className="full">
                      <label
                        className={`input_label active`}
                        htmlFor="package"
                      >
                        Package
                      </label>
                      <select className="input_field" onChange={handleSelectChange}>
                        <option>Open Seas</option>
                        <option>Rum Run</option>
                        <option>Tranquil tides</option>
                        <option>Montego Bay Luxe</option>
                        <option>The Deux Ex Machina Signature</option>
                      </select>
                    </li>
                    <li className="full">
                      <label
                        className={`input_label`}
                        htmlFor="message"
                      >
                        Message
                      </label>
                      <textarea
                        className="input_field"
                        id="message"
                        name="message"
                        onChange={handleFormChange}
                        maxLength={1000}
                      ></textarea>
                    </li>
                    <li className="full">
                      <p>
                        Deus Ex Machina processes the information
                        entered through this form to reply to your request.
                      </p>
                    </li>
                    <li className="full">
                      <label htmlFor="check" className="form_check">
                        <input type="checkbox" id="check" onChange={handleNewsletterCheckbox} />
                        <span>
                          Subscribe to our newsletter to remain up to date
                          with the latest news from the Deus Ex Machina's
                          world.
                        </span>
                      </label>
                    </li>
                    <li> {/* reCAPTCHA v3 */}
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Lcn__MqAAAAAHC8YEGaWpNuqFQi9Sr1V1yQWk3s"
                        size="invisible"
                        onChange={(token) => handleFormSubmit(token)}
                      /></li>
                    <li className="subbutton full">
                      <button className="simple_btn" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </li>
                  </ul>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}